import { WitnessProtection } from "types";
import apiClient from "../lib/apiClients";

// WitnessProtection
export const fetchWitnessProction = async () => {
  const response = await apiClient.get<WitnessProtection[]>(
    "/witness_protection/witness-protection/"
  );
  return response.data;
};
export const fetchWitnessProctionForCoordinator = async (
  admin_unit: string,
  role: string
) => {
  const response = await apiClient.get<WitnessProtection[]>(
    `/witness_protection/witness-protection/by-admin-coordinator/?admin_unit=${admin_unit}&&coordinator_role=${role}`
  );
  return response.data;
};
export const fetchWitnessProctionForRegistrar = async (admin_unit: string) => {
  const response = await apiClient.get<WitnessProtection[]>(
    `/witness_protection/witness-protection/filter-by-admin/?admin_unit=${admin_unit}`
  );
  return response.data;
};
export const fetchWitnessProctionByAssignedProsecutor = async (
  prosecutor_id: string | number
) => {
  const response = await apiClient.get<WitnessProtection[]>(
    `/witness_protection/witness-protection/by-assigned-prosecutor/?assign_prosecutor_id=${prosecutor_id}`
  );
  return response.data;
};
export const fetchWitnessProctionById = async (id: string) => {
  const response = await apiClient.get<WitnessProtection>(
    "/witness_protection/witness-protection/" + id + "/"
  );
  return response.data;
};
export const addWitnessProction = async (data: WitnessProtection) => {
  const response = await apiClient.post(
    "/witness_protection/witness-protection/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editWitnessProction = async (data: any) => {
  const response = await apiClient.patch(
    "/witness_protection/witness-protection/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editWitnessProction2 = async (data: any) => {
  const response = await apiClient.patch(
    "/witness_protection/witness-protection/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deleteWitnessProction = async (reporter: WitnessProtection) => {
  const response = await apiClient.delete(
    "/witness_protection/witness-protection/" + reporter?.id + "/"
  );
  return response.data;
};

// Witness
export const addWitnessToWitnessProction = async (data: WitnessProtection) => {
  const response = await apiClient.post("/witness_protection/witnesses/", data);
  return response.data;
};
export const editWitnessToWitnessProction = async (data: any) => {
  const response = await apiClient.patch(
    "/witness_protection/witnesses/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deleteWitnessToWitnessProction = async (
  reporter: WitnessProtection
) => {
  const response = await apiClient.delete(
    "/witness_protection/witnesses/" + reporter?.id + "/"
  );
  return response.data;
};
